import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import MediathequeSection from "../../Components/MediathequeSection/MediathequeSection";
import Slideshow from "../../Components/SlideShow/Slideshow";
import styles from "./MediathequePage.module.css";
import slideShowIcon from "../../Assets/Icons/slideshow.png";
import compareModeIcon from "../../Assets/Icons/comparemode.png";
import FileService from "../../Services/fileService";
import { addToast } from "../../Services/toastService";
import i18n from "../../Services/i18n";
import UserServiceService from "../../Services/userServiceService";
import ErrorBoundary from "../../Components/ErrorBoundary";
import CrashTest from "../../Components/CrashTest";
const MediathequePage = () => {
  const [isCompareMode, setIsCompareMode] = useState(false);
  const [openSlideshow, setOpenSlideshow] = useState(false);
  const [folderTreeData, setFolderTreeData] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [services, setServices] = useState([]);
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);

  const ref1 = useRef();
  const ref2 = useRef();

  const location = useLocation();
  const { paramClientId } = location.state || {};
  const { paramHorseId } = location.state || {};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await FileService.getFolderBrowser(paramClientId, paramHorseId);
        if (data) {
          setFolderTreeData(data);
          setSelectedFolder({ folderUId: data.initialUid });
        }

        const servicesList = await UserServiceService.GetUserServiceList();
        setServices(servicesList);
      } catch (ex) {
        addToast(i18n.t("Generic.ServerError"), "BACKENDERROR", "ERROR", true);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggleCompareMode = () => {
    if (!isCompareMode) {
      setFileData(ref1.current.getData().fileFolderBroswerData);
      setSelectedFolder(ref1.current.getSelectedFolder());
    }
    setIsCompareMode(!isCompareMode);
  };

  const handleOpenSlideshow = () => {
    setList1(ref1.current.getData().fileFolderBroswerData);
    setList2(ref2?.current?.getData().fileFolderBroswerData);
    setOpenSlideshow(true);
  };

  const renderMenuBar = () => {
    return (
      <>
        {openSlideshow && (
          <Slideshow list1={list1} list2={list2} onClose={() => setOpenSlideshow(false)} />
        )}
        <div className={styles.menuBar}>
          <div
            onClick={() => {
              handleToggleCompareMode();
            }}
            title="Compare Mode"
            className={`${styles.iconButton} ${isCompareMode ? styles.iconButtonchecked : ""}`}>
            <img src={compareModeIcon} alt="Compare Mode" />
          </div>

          <div
            onClick={() => handleOpenSlideshow()}
            title="SlideShow"
            className={styles.iconButton}>
            <img src={slideShowIcon} alt="SlideShow" />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className={isCompareMode ? styles.containerCompare : styles.containerSingle}>
        {renderMenuBar()}

        <MediathequeSection
          ref={ref1}
          compareMode={isCompareMode}
          reverseCol={false}
          folderTreeData={folderTreeData}
          initialData={fileData}
          initialSelectedFolder={selectedFolder}
          services={services}
        />

        {isCompareMode && (
          <MediathequeSection
            ref={ref2}
            compareMode={true}
            reverseCol={true}
            folderTreeData={folderTreeData}
            initialData={fileData}
            initialSelectedFolder={selectedFolder}
            services={services}
          />
        )}
      </div>
    </>
  );
};

export default MediathequePage;
